module.exports = __webpack_public_path__ + "media/images/gallery/constellations/sagitta/sge_names-87f47a61d6b98508e98a8c347e471481.gif";